import { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Carica lingua salvata o usa italiano come default
    return localStorage.getItem('jc_language') || 'it';
  });

  useEffect(() => {
    // Salva la lingua in localStorage
    localStorage.setItem('jc_language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Ritorna la chiave se la traduzione non è trovata
      }
    }
    
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
